import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-032926df"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-global-skeleton tw-w-full tw-h-full" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = ["id"]

import { ApexOptions } from "apexcharts";
import { PropType } from "vue";

export interface IChartSeries {
  name: string;
  data: number[];
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'radarChart',
  props: {
  chartId: {
    type: Number,
    required: false,
    default: 1,
  },
  loading: {
    type: Boolean,
    required: false,
    default: false,
  },
  height: {
    type: [Number, String],
    required: true,
  },
  series: {
    type: Object as PropType<IChartSeries[]>,
    required: true,
  },
  chartOptions: {
    type: Object as PropType<ApexOptions>,
    default: () => ({
      chart: { toolbar: { show: false } },
      // plotOptions: {
      //   radar: {
      //     polygons: {
      //       strokeColor: '#e8e8e8',
      //       strokeWidth: 1,
      //       connectorColors: '#e8e8e8',
      //       fill: {
      //           colors: ['#000000', '#fff']
      //       }
      //     }
      //   }
      // },
      // xaxis: {
      //   categories: ['January', 'February', 'March', 'April', 'May', 'June']
      // },
      // yaxis: { stepSize: 20 },
      // fill: { },
      // grid: {},
    }),
    required: true,
  },
  heightLoading: {
    type: Number || String,
    default: 0,
  },
  classChart: {
    type: String,
    default: "",
  },
  id: {
    type: String,
    default: "radar-chart",
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (__props.loading)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "tw-flex tw-w-full",
        style: _normalizeStyle(`height: ${__props.heightLoading ? __props.heightLoading + 'px' : '100%'}`)
      }, _hoisted_2, 4))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        id: __props.id,
        class: "container tw-overflow-y-hidden"
      }, [
        (_openBlock(), _createBlock(_component_apexchart, {
          key: __props.chartId,
          height: __props.height,
          width: '100%',
          type: 'radar',
          options: __props.chartOptions,
          series: __props.series,
          class: _normalizeClass(`!tw-min-h-[0px] ${__props.classChart}`)
        }, null, 8, ["height", "options", "series", "class"]))
      ], 8, _hoisted_3))
}
}

})